import { memo } from 'react';
import { Box, Skeleton } from '@bonanza-social/moonlight';
import { PrizeWallWinnersSkeletonProps } from './PrizeWallWinnersSkeleton.types';

function PrizeWallWinnersSkeleton(props: PrizeWallWinnersSkeletonProps) {
  return (
    <Box flex={1} paddingHorizontal="space-400" {...props}>
      <Skeleton height={20} marginTop="space-600" marginBottom="space-200" />
      <Skeleton
        height={32}
        marginHorizontal="space-400"
        marginBottom="space-600"
      />
      <Skeleton flex={1} borderRadius="radius-300" />
    </Box>
  );
}

export default memo(PrizeWallWinnersSkeleton);
